import property from './property-image-modules/property.json';
import activities from './property-image-modules/activities.json';
import room from './property-image-modules/room.json';

export default [
  {
    key: 'PROPERTY',
    children: property,
  },
  {
    key: 'ACTIVITIES',
    children: activities,
  },
  {
    key: 'ROOM',
    children: room,
  },
];
